import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MoreIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchIconImg from '../Img/search icon.png';
import { Avatar, Button, Typography } from '@mui/material';
import userImg from '../Img/user.png';
import logoutIconImg from '../Img/logout-icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { removeAuthToken } from '../common/common';
import { useState } from 'react';
import { useNavigate } from 'react-router';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '0.75rem',
  backgroundColor: '#fff',
  border: '1px solid var(--color-border-soft)',
  boxShadow: '0 4px 12px rgba(21,51,86,0.06)',
  '&:hover': {
    backgroundColor: '#fff',
  },
  marginRight: theme.spacing(1),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(0.85, 1, 0.85, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    fontSize: '0.8rem',
    [theme.breakpoints.up('md')]: {
      width: '32ch',
    },
  },
}));

export default function Header({ setSearch, onOpenMobileNav }) {
  const navigate = useNavigate();
  useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const { loggedIn } = useSelector((state) => state.authData);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleLogout = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
    removeAuthToken();
    navigate('/login');
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{ marginTop: 2 }}
      MenuListProps={{
        sx: {
          borderRadius: '0.65rem',
          border: '1px solid var(--color-border-soft)',
          minWidth: 140,
        },
      }}
    >
      <MenuItem
        sx={{
          py: 0.7,
          px: 1.3,
          color: 'var(--color-heading)',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 0.7,
          borderRadius: '0.5rem',
          fontSize: '0.82rem',
        }}
        onClick={handleLogout}
      >
        <img src={logoutIconImg} alt="logoutIconImg" />
        <div>Log Out</div>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      sx={{ padding: '0px' }}
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem component="a" href="/patientcalendar" target="_blank" rel="noopener noreferrer">
        <OpenInNewIcon fontSize="small" />
        <p style={{ margin: 0, marginLeft: 8 }}>Book Appointment</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <Avatar alt={loggedIn?.name || 'User'} src={userImg} sx={{ width: 26, height: 26 }} />
        <p style={{ margin: 0, marginLeft: 8 }}>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1, pb: 0.9 }}>
      <Box sx={{ backgroundColor: 'transparent' }}>
        <Toolbar
          sx={{
            p: '0 !important',
            gap: 1,
            minHeight: 'unset !important',
            alignItems: 'center',
          }}
        >
          {onOpenMobileNav && (
            <IconButton
              color="inherit"
              aria-label="open navigation menu"
              edge="start"
              onClick={onOpenMobileNav}
              sx={{
                display: { xs: 'inline-flex', md: 'none' },
                backgroundColor: '#fff',
                border: '1px solid var(--color-border-soft)',
                boxShadow: '0 2px 8px rgba(21,51,86,0.1)',
                borderRadius: '8px',
                width: 34,
                height: 34,
              }}
            >
              <MenuIcon sx={{ color: 'var(--color-heading)', fontSize: 20 }} />
            </IconButton>
          )}
          <Search>
            <SearchIconWrapper>
              <img src={SearchIconImg} alt="search" height="16" />
            </SearchIconWrapper>
            <StyledInputBase placeholder="Search…" inputProps={{ 'aria-label': 'search' }} onChange={(e) => setSearch(e.target.value)} />
          </Search>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: '.5rem' }}>
            <Button
              component="a"
              href="/patientcalendar"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              className="dialogSubmitBtn"
              size="small"
              endIcon={<OpenInNewIcon sx={{ fontSize: 15 }} />}
              sx={{ minHeight: 34, px: 1.2, borderRadius: '8px', fontSize: '0.76rem', boxShadow: 'none' }}
            >
              Book Appointment
            </Button>
            <Box
              sx={{
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: 0.9,
                borderRadius: '999px',
                border: '1px solid var(--color-border-soft)',
                boxShadow: '0 2px 10px rgba(21,51,86,0.08)',
                pl: 1.2,
                pr: 1.1,
                minHeight: 40,
                cursor: 'pointer',
              }}
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', lineHeight: 1.2, minWidth: 92 }}>
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--color-heading)' }}>
                  {loggedIn?.name || 'User'}
                </Typography>
                <Typography sx={{ fontSize: '0.72rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>
                  {loggedIn?.role === 'SA' ? 'SuperAdmin' : loggedIn?.role === 'A' ? 'Admin' : loggedIn?.role === 'D' ? 'Doctor' : 'User'}
                </Typography>
              </Box>
              <Avatar alt={loggedIn?.name || 'User'} src={userImg} sx={{ height: 34, width: 34, border: '1px solid var(--color-border)' }} />
            </Box>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="small"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
              sx={{
                backgroundColor: '#fff',
                border: '1px solid var(--color-border-soft)',
                boxShadow: '0 2px 8px rgba(21,51,86,0.1)',
                borderRadius: '8px',
                width: 34,
                height: 34,
              }}
            >
              <MoreIcon sx={{ fontSize: 20, color: 'var(--color-heading)' }} />
            </IconButton>
          </Box>
        </Toolbar>
      </Box>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
